
export const API_ENDPOINTS = {

  AUTH: {
    LOGIN: '/auth/login',
    FORGOT_PASSWORD_SEND_OTP: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
    SIGNUP: '/auth/signup',
    VERIFY_OTP: '/auth/verify-otp',
    RESEND_OTP: '/auth/resend-otp',
    PROFILE_UPDATE: '/auth/user/profile/update',
    PROFILE_GET: '/auth/me',
  },

  USER: {
    USER_LIST: '/users/user-list',
    USER_DELETE: 'users/{{id}}/delete-user',
    CREATE_USER: '/users/add-user',
    GET_USER_DETAIL: '/users/get-user-detail',
    UPDATE_USER: '/users/update-user',
  },

  TEMPLATE: {
    TEMPLATE_LIST: '/template/template-list',
    CREATE_TEMPLATE: '/template/create-template',
    GET_TEMPLATE_DETAIL: '/template/{{id}}',
    DELETE_TEMPLATE: '/template/delete-template/{{id}}',
    DOWNLOAD_TEMPLATE: '/template/download-template/{{id}}',
    TEMPLATE_FOR_USER: '/data-upload/kpi-list',
    UPLOAD_TEMPLATE: '/data-upload/validate-and-upload-template',
    DELETE_TEMPLATE_DATA: '/data-upload/clean-template-data',
  },

  COMMON: {
    PHONE_CODE: '/master/phone-codes',
    ROLE_LIST: '/master/role-lists',
    ACCESS_LEVEL_LIST: '/master/access-level-list',
    PERMISSION_LIST: '/master/permissions',
    INDICATOR_LIST: '/master/indicators?page=1&page_size=50',
  },

  ROLE: {
    ROLE_LIST: '/roles/',
    CREATE_ROLE: '/roles/',
    UPDATE_ROLE: '/roles/{{id}}',
    DELETE_ROLE: '/roles/{{id}}',
  },

  PERMISSION: {
    PERMISSION_LIST: '/roles/permissions',
    CREATE_PERMISSION: '/roles/permissions',
    UPDATE_PERMISSION: '/roles/permissions/{{id}}',
    DELETE_PERMISSION: '/roles/permissions/{{id}}',
  },

  CHART: {
    GET_CHART_LIST: '/superset/indicators?page=1&page_size=50',
    GET_CHART_DETAILS: '/superset/api/kpi-charts/kpi/{{id}}',
    GET_CHART_DATA: '/charts/total-row-count',
    GET_CHART_DATA_BY_KPI: '/charts/chart-by-kpi?kpi_id={{kpi_id}}',
    CBK: '/charts-poc/chart-by-kpi?',
  },

  ACTIVITY_LOG: {
    GET_ACTIVITY_LOG: '/log/system-logs',
  },

  DATA_HOUSE: {
    GET_DATA_HOUSE: '/data-management/data-list',
    GET_DATA_HOUSE_DETAILS: '/data-management/data-list-meta',
    DELETE_DATA_HOUSE: '/data-management/delete-template-data',
  },


} as const;



 